// viewed from contexts
export const PageContext = {
  BLOCKPAGE: 'blockpage',
  MODAL: 'modal',
  HISTORY: 'history',
  WEBVIEW: 'webview',
};

// modes
export const PageMode = {
  VIEW: 'view',
  EDIT: 'edit',
  FOCUS: 'exhibit', // at the moment the two are mixed up
};

export const BlockMode = {
  DISPLAY: 'display', // display the widget's main content
  SETUP: 'setup', // display the widget's authoring/settings
  LAYOUT: 'layout',
  EXHIBIT: 'exhibit', // display as a post exhibit (when rendered in a post)
  FOCUS: 'focus', // not used for now (display submissions from another user, e.g. assessment)

  // block tabs
  SHARING: 'sharing',
  PROGRESS: 'progress',
  LTI_SETUP: 'content-selection',
};

// Note: the names are terrible
// colSize "cols1" = half width
// colSize "cols2" = full width
export const ColumnWidth = {
  HALF: 'cols1',
  FULL: 'cols2',
};

export const ColumnGroup = {
  LEFT: 'A',
  RIGHT: 'B',
};
